/**
 * Base map and palette for the world map.
 *
 * The base map is OpenFreeMap's dark style: OpenStreetMap-based vector tiles,
 * labels and fonts, served without a key. The game's own layers (routes,
 * airports, aircraft) are added on top of it by WorldMap. Colours are literals
 * because MapLibre paint properties cannot read CSS variables; the values mirror
 * the `--ocean`, `--land` and `--accent` tokens in styles.css.
 */
import type { AirportTier } from './mapGeometry';

/** OpenStreetMap data, rendered by OpenFreeMap. Attribution is shown by the map's attribution control. */
export const BASE_STYLE_URL = 'https://tiles.openfreemap.org/styles/dark';

export const MAP_COLORS = {
  ocean: '#0d1a30',
  land: '#1b2b48',
  coast: '#2a3f66',
  graticule: '#16294a',
  routeIdle: '#3b6db3',
  routeActive: '#4da3ff',
  planeFill: '#ffd166',
  planeOutline: '#1b1300',
  closure: '#ff3b3b',
} as const;

/** Colours are shared by the airport layer and the legend. */
export const TIER_COLORS: Readonly<Record<AirportTier, string>> = {
  HQ: '#c6ff4d',
  HUB: '#3ddc84',
  NETWORK: '#2bb673',
  OTHER: '#6fbf94',
};

export const TIER_LABELS: Readonly<Record<AirportTier, string>> = {
  HQ: 'Headquarters',
  HUB: 'Hub',
  NETWORK: 'Network',
  OTHER: 'Not served',
};
